import { arquivos, integracoes, metas, regras, relatorios, vendas, vendedores } from './permissions';

export default {
  vendas: vendas.vendas,
  'arquivos-status': arquivos.arquivos.status,
  'arquivos-upload': arquivos.arquivos.upload,
  relatorios: relatorios.relatorios,
  vendedores: vendedores.vendedores,
  'metas-configurar': metas.metas.configurar,
  'metas-exportar-model': metas.metas.exportar,
  'metas-importar-modelo': metas.metas.importar,
  'metas-estagio-configuracao': metas.metas.configurar,
  'integracoes-marketplace': integracoes.integracoes.marketplace,
  'integracoes-configuradas': integracoes.integracoes.configuradas,
  'integracoes-chamadas': integracoes.integracoes.consultas,
  regras: regras.regras
};
